import * as React from "react";

import Auth from "./auth";

export function OpenDashAuth() {
  return <Auth />;
}
